export default class PaxReport {
  count: number;
  ends: string;
  starts: string;
}
